var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOzenlinot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0376 32L23.1362 31.2488C20.1315 28.3944 18.0282 26.5916 18.0282 24.338C18.0282 22.5352 19.5305 21.0329 21.3333 21.0329C22.385 21.0329 23.4366 21.4836 24.0376 22.2347C24.6385 21.4836 25.6901 21.0329 26.7418 21.0329C28.5446 21.0329 30.0469 22.385 30.0469 24.338C30.0469 26.5916 27.9437 28.3944 24.939 31.2488L24.0376 32ZM21.0329 3.00469V12.0188L18.0282 9.01408L15.0235 12.0188V3.00469H9.01408V27.0423H15.1437C15.3239 28.1239 15.6995 29.1305 16.2254 30.0469H6.00939C4.43193 30.0469 3.00469 28.6197 3.00469 27.0423V25.5399H0V22.5352H3.00469V16.5258H0V13.5211H3.00469V7.51174H0V4.50704H3.00469V3.00469C3.00469 1.33709 4.35681 0 6.00939 0H24.0376C25.615 0 27.0423 1.42723 27.0423 3.00469V17.0366C26.0958 16.7061 25.0892 16.5258 24.0376 16.5258V3.00469H21.0329ZM3.00469 25.5399H6.00939V22.5352H3.00469V25.5399ZM3.00469 16.5258H6.00939V13.5211H3.00469V16.5258ZM3.00469 7.51174H6.00939V4.50704H3.00469V7.51174Z",
    fill: "#3733BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzenlinot);
export default __webpack_public_path__ + "static/media/ozenlinot.b1bf2eef9256a46113905d37aebc00c1.svg";
export { ForwardRef as ReactComponent };